import { render, staticRenderFns } from "./RegistryModal.vue?vue&type=template&id=61a2129e"
import script from "./RegistryModal.vue?vue&type=script&lang=js"
export * from "./RegistryModal.vue?vue&type=script&lang=js"
import style0 from "./RegistryModal.vue?vue&type=style&index=0&id=61a2129e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports